import PropTypes from 'prop-types';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import { Box, InputAdornment } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';

import { getIsMonthBeforeNow } from './utils';

import StyledTextField from '../Shared/StyledTextField';

const DateTimeFnsPicker = (props) => {
  const { value, onChange } = props;

  const textField = (params) => (
    <StyledTextField
      {...params}
      helperText=""
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <EventNoteOutlinedIcon />
          </InputAdornment>
        ),
      }}
    />
  );

  const textTimeField = (params) => (
    <StyledTextField
      {...params}
      helperText=""
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <AccessTimeIcon />
          </InputAdornment>
        ),
      }}
    />
  );

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box display="flex" gap="1.5rem">
        <MobileDatePicker
          value={value ? new Date(value) : null}
          onChange={onChange}
          slots={{ textField }}
          disableFuture
          shouldDisableDate={getIsMonthBeforeNow}
          localeText={{
            toolbarTitle: '',
          }}
        />
        <MobileTimePicker
          slots={{ textField: textTimeField }}
          value={value ? new Date(value) : null}
          onChange={onChange}
        />
      </Box>
    </LocalizationProvider>
  );
};

DateTimeFnsPicker.propTypes = {
  value: PropTypes.instanceOf(Object).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default DateTimeFnsPicker;
